import { useCallback } from 'react'

export function useEditing(setEditingState: (inEditing: boolean) => void) {
  const onCancel = useCallback(() => setEditingState(false), [setEditingState])
  const onEdit = useCallback(() => setEditingState(true), [setEditingState])

  return { onEdit, onCancel }
}
